import { ApiServices } from "../../services/api_services";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { config } from "../../base/constant";

const loginUser = createAsyncThunk(
  "authentication/login",
  async (userData: any) => {
    const userInformation = {
      ...userData,
      source: "CCAAS:BROWSER",
      ipAddress: "136.144.56.255:443",
      isForceLogin: false,
      deviceId: "string",
    };
    return ApiServices.login(
      `${config().BASE_URL}/ccaasAuth/v1`,
      "/token/create_jwt",
      userInformation
    )
      .then((response: any) => response)
      .catch((error: any) => error);
  }
);

const sendResetLink = createAsyncThunk(
  "authentication/sendResetLink",
  async (email: any, thunkApi) => {
    return ApiServices.post(
      "http://10.150.0.246:5002/urauth/v1",
      "/forgot_password",
      {
        called_by: "APP",
        emailId: `${email.trim()}`,
        log_id: 0,
        new_pwd: "",
        type: 1,
      }
    )
      .then((response: any) => response)
      .catch((error: any) => error);
  }
);

const resendResetLink = createAsyncThunk(
  "authentication/resendResetLink",
  async (userEmail: any) => {
    return ApiServices.post(
      "http://10.150.0.246:5002/urauth/v1",
      "/forgot_password",
      {
        called_by: "APP",
        emailId: `${userEmail.trim()}`,
        log_id: 0,
        new_pwd: "",
        type: 1,
      }
    )
      .then((response: any) => response.data)
      .catch((error: any) => error);
  }
);

export { loginUser, sendResetLink, resendResetLink };
